import routerOptions0 from "/usr/src/app/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: true,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}